const _ = require('lodash');

function validateValue (value, locator) {
    if (value && typeof value !== 'number') {
        locator.resolve('logger').error(`Value metric: ${value} must be a number`);

        return false;
    }

    return true;
}

/**
 * @param {string} category
 * @param {string} resultAction
 * @returns {Promise}
 */
function validateArgs (category, resultAction) {
    return new Promise((res, rej) => {
        if (!_.isString(category) || !resultAction) {
            return rej(`Unrecognized validateArgs arguments: ${[].join.call(arguments)}`);
        }

        res(Array.prototype.slice.call(arguments));
    });
}

module.exports = {
    parseUtmFromQuery (args, state, output, { context }) {
        var utils = require('../helpers/utils');

        if (context.location.query) {
            var utm = _.pick(
                    context.location.query.values,
                    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
            state.set('utm', utm);
        }
    },

    /**
     * Регистрирует показ страницы
     *
     * @param {Object} args
     * @param {Baobab} state
     * @param {function} output
     * @param {Object} services
     * @param {Object} services.locator
     * @param {Object} services.context
     */
    pageview (args, state, output, { locator, context }) {
        if (context.isServer) {
            return;
        }

        let analytics = locator.resolve('analytics');
        let title = state.get('title');
        let role = state.get(['user', 'role']);

        analytics.pageview({ title, role });
    },

    /**
     * Создание простого экшена для аналитики
     *
     * @param {String} category
     * @param {String} action
     * @param {String|undefined} label
     * @param {String|Boolean|Number} [value]
     * @return {function}
     */
    event (category, action, label, value) {
        /**
         * @param {Object} args
         * @param {Baobab} state
         * @param {function} output
         * @param {Object} services
         * @param {Object} services.locator
         * @param {Object} services.context
         */
        return function customEvent (args, state, output, { locator, context }) {
            if (context.isServer) {
                return;
            }

            if (!validateValue(value, locator)) {
                return;
            }

            let analytics = locator.resolve('analytics');
            let role = state.get(['user', 'role']);

            analytics.event({ role }, category, action, label, value);
        };
    },

    /**
     *
     * Супер метод, подходит для всей аналитики
     *
     * @param {Object} options
     * @param {String} options.category - Имя категории
     * @param {Object|String} options.action - либо строка с названием экшена либо объект с
     *   несколькими значениями
     * @param {Object|String} options.label - либо строка с названием лейбла либо объект с
     *   несколькими значениями
     * @param {String|undefined} options.argsAction - ключ для объекта с экшенами
     * @param {String|undefined} options.argsLabel - ключ для объекта с лейблами
     * @param {String|undefined} options.valueField - ключ для агрумента с велью
     * @return {function} argsDependentEvent
     *
     * @example
     * analytics.argsValueEvent({
          category: 'photo',
          action: {
            addedByCompany: 'addedByCompany',
            addedByOtherSource: 'addedByOtherSource'
          },
          label: {
            active: 'unhide',
            hidden: 'hide'
          },
          argsAction: 'action',
          argsLabel: 'status',
          valueField: 'metricValue'
        })
     *
     */
    argsValueEvent ({ category, action, label, argsAction, argsLabel, valueField }) {
        /**
         * Кастомное событие зависящее от переданного аргумента
         *
         * @param {Object} args
         * @param {Baobab} state
         * @param {function} output
         * @param {Object} services
         * @param {Object} services.locator
         * @param {Object} services.context
         */
        return function stateValueEvent (args, state, output, { locator, context }) {
            if (context.isServer) {
                return;
            }

            let role = state.get(['user', 'role']);

            let actionValue = args[argsAction];
            let labelValue = args[argsLabel];
            let metricValue = args[valueField];

            let value = valueField ? metricValue : null;
            let resultAction = _.isString(action) ? action : action[actionValue];
            let resultLabel = label && (_.isString(label) ? label : label[labelValue]);

            if (!validateValue(value, locator)) {
                return;
            }

            validateArgs(category, resultAction, resultLabel, value)
                .then((event) => locator.resolve('analytics').event({ role }, ...event))
                .catch((err) => err && locator.resolve('logger').error(err));
        };
    },

    raiseArgsValueEvent ({ category, action, label, value }, state, output, { locator, context }) {
        if (context.isServer) {
            return;
        }

        if (!validateValue(value, locator)) {
            return;
        }

        let role = state.get(['user', 'role']);
        validateArgs(category, action, label, value)
            .then((event) => locator.resolve('analytics').event({ role }, ...event))
            .catch((err) => err && locator.resolve('logger').error(err));
    },

    /**
     * Заполняем аргументы для события
     * @param {Object} args
     * @param {Baobab} state
     * @param {Object} output
     */
    fillEvent ( args, state, output) {
        if (!args.value) {
            output.noEvent();
        }

        delete args.value;
        output.filled({ action: args.action });
    },

    /**
     * Заполняем аргументы для события при выборе элемента дерева
     * @param {Object} args
     * @param {Baobab} state
     * @param {Object} output
     */
    fillEventFromTreeChecked (args, state, output) {
        if (!args.value) {
            output.noEvent();
        }

        delete args.value;
        output.filled({ action: 'input' });
    },

    /**
     * Заполняем аргументы для события при выборе дополнительных параметров выгрузки
     * @param {Object} args
     * @param {Baobab} state
     * @param {Object} output
     */
    fillEventArgsFromAdditionalParamSet (args, state, output) {
        if (args.value == false) {
            output.noEvent();
            return;
        }

        let column = _.find(state.get(['order', 'originalParameters', 'exportColumns', 'columns']),
            (x) => x.id == Number(args.path));

        var metricEvent = args.metricEventPrefix + column.propertyName.toLowerCase();

        delete args.value;
        output.filled({ category: metricEvent, action: 'input' });
    },

    /**
     * Заполняем аргументы для события при отображении заказа в определённом статусе
     * @param {Object} args
     * @param {Baobab} state
     * @param {Object} output
     */
    fillEventOnOrderLoaded (args, state, output) {
        let metricEvent;
        switch (state.get(['account', 'orders', 'currentOrder', 'stateId'])) {
            // черновик
            case 1:
                metricEvent = 'open_order_page_draft'
                break;
            // на оформлении
            case 2:
                metricEvent = 'open_order_page_invoice_hold'
                break;
            // Готов к оплате
            case 3:
                metricEvent = 'open_order_page_money_hold'
                break;
            // Ожидает документы
            case 4:
                metricEvent = 'open_order_page_paid'
                break;
            // Выполнен
            case 5:
                metricEvent = 'open_order_page_paid'
                break;
            // Черновик
            case 6:
                metricEvent = 'open_order_page_archive'
                break;
            default:
                output.noEvent();
                return;
        }

        output.filled({ category: metricEvent, action: 'see' });
    },

    /**
     * Заполняем аргументы для события при отображении заказа с прикреплёным документом Счёт
     * @param {Object} args
     * @param {Baobab} state
     * @param {Object} output
     */
    fillEventIfBillAttached (args, state, output) {
        const documents = state.get(['account', 'orders', 'currentOrder', 'necessaryDocuments']);
        const stateId = state.get(['account', 'orders', 'currentOrder', 'stateId']);

        // если заказ уже оплачен, то событие не нужно
        if (stateId >= 4) {
            output.noEvent();
            return;
        }

        const billDocuments = _.filter(documents, function (doc) {
            return (doc.typeId === 1 && doc.id);
        });

        if (billDocuments.length > 0) {
            output.filled({ category: 'open_order_page_invoice_loaded', action: 'see' });
            return;
        }

        output.noEvent();
    }
};



// WEBPACK FOOTER //
// ./actions/analytics.js